import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import store from './store'

Vue.use(Router)

let toNext = ''
// TODO: Not sure crawlers see these titles

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior (to, from, savedPosition) {
    if (to.hash) {
      return {
        selector: to.hash
      }
    } else if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      meta: {
        title: ''
      }
    },
    {
      path: '/kontakt',
      name: 'kontakt',
      // route level code-splitting, same comment "webpackChunkName" results in same async chunk
      component: () =>
        import(/* webpackChunkName: "nyheter" */ './views/Contact.vue'),
      meta: {
        title: 'Kontakta oss'
      }
    },
    {
      path: '/about',
      name: 'about',
      // route level code-splitting, same comment "webpackChunkName" results in same async chunk
      component: () =>
        import(/* webpackChunkName: "nyheter" */ './views/About.vue'),
      meta: {
        title: 'Om oss'
      }
    },
    {
      path: '*',
      redirect: '/'
    }
  ]
})

router.beforeEach((to, from, next) => {
  document.title =
    'NPC Power Club ' + `${to.meta.title ? ' | ' + to.meta.title : ''}`
  // eslint-disable-next-line
  const currentUser = firebase.auth().currentUser
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)

  if (requiresAuth && !currentUser) {
    toNext = to
    store.commit('openLoginModal')
    next(false)
    return
    // eslint-disable-next-line brace-style
  } else if (toNext !== '') {
    let toNextCopy = toNext
    toNext = ''
    next(toNextCopy)
  }

  // later when we have a profil page and want to show a special page for logged in users

  // else if (!requiresAuth && currentUser) next('home')

  next()
})

export default router
